import reducer from "./reducer"
import saga from "./saga"
import { MODULE_NAME } from "./helpers"

export { requestUser, requestPermissions } from "./actions/creators"
export {
  selectRoles,
  selectUser,
  selectPermissions,
  selectUserStatus,
  selectPermissionsStatus,
  hasRole,
  hasPermission,
} from "./selectors"

const name = MODULE_NAME
export { name, reducer, saga }
